const helperServiceAuth = {
	/**
	 * @author Jared
	 * @description  The Function checks the user role whether is admin or not
	 *
	 * @param {Object} vars - Accept users detail object that includes user type info
	 *
	 * @return {Boolean} Admin Status
	 *
	 */
	admin: vars => {
		return vars.user && vars.user.userType === 'admin'
	},
	/**
	 * @author Jared
	 * @description  Get the user's tier - note the tiers are
	 * 1. Free User
	 * 2. Startpu or Basic User
	 * 3. Pro User
	 * 4. Enterprise User
	 * 5. First User
	 *
	 * This is experiential, NOT administrative. It is possible to be both Tier I and a master admin
	 *
	 * We return a number so that code can be expressed as a greater than or less than experience
	 *
	 * @param {Object} vars - Accept users detail object that includes user type info
	 *
	 * @return {Number} Tier
	 * Added Aggie Light in tiers array for getting tier for latest free plan
	 */
	tier: vars => {
		const tiers = [
			{tier: 1, plans: ['AGGIE Solo']},
			{tier: 1, plans: ['AGGIE Light']},
			{tier: 2, plans: ['AGGIE Startup']},
			{tier: 3, plans: ['AGGIE Pro']},
			{tier: 4, plans: ['AGGIE Enterprise']},
			{tier: 5, plans: ['AGGIE First User']}
		]

		return tiers.find(tier => tier.plans[0]?.toLowerCase().includes(vars.user.planName?.toLowerCase()))?.tier
	}
}

export default helperServiceAuth
